import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

interface InterviewBadgeProps {
    interview_eng?: string;
    interview_tch?: string;
}

export const InterviewBadge: React.FC<InterviewBadgeProps> = ({ interview_eng, interview_tch }) => {
    // Use English by default (can be enhanced with language context later)
    const interviewText = interview_eng || interview_tch;

    // Don't render if no interview information is available
    if (!interviewText) {
        return null;
    }

    // Color based on interview requirement
    const isRequired = interviewText.toLowerCase().includes('yes');
    const colorClass = isRequired 
        ? 'bg-amber-50 text-amber-700 border-amber-200' 
        : 'bg-emerald-50 text-emerald-700 border-emerald-200';

    const displayText = interviewText === 'No' ? 'Interview: ✗' : 'Interview: ✓';
    const showTooltip = true; // interviewText !== 'No';

    const badgeContent = (
        <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium border ${colorClass} ${showTooltip ? 'cursor-help' : ''}`}>
            {displayText}
        </span>
    );

    if (!showTooltip) {
        return badgeContent;
    }

    return (
        <Tooltip delayDuration={200}>
            <TooltipTrigger asChild>
                {badgeContent}
            </TooltipTrigger>
            <TooltipContent 
                side="top" 
                sideOffset={5}
                className="px-3 py-2 text-sm bg-gray-900 text-white rounded-lg shadow-lg border-0 max-w-xs"
            >
                {interviewText}
            </TooltipContent>
        </Tooltip>
    );
};
